import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { Observable } from 'rxjs';
import {NewLoansService} from "./new-loans.service";
import {map} from "rxjs/operators";
import {DocumentsKeyEnum} from "@brightside-web/shared/legal-documents";

@Injectable()
export class LoanHasLegalGuard implements CanActivate {

  constructor(
    private newLoansService: NewLoansService,
    private router: Router
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.newLoansService.doesLoanHaveDocs().pipe(
      map((docKey: DocumentsKeyEnum | boolean) => {
        if (!docKey) {
          return true;
        } else {
          if (typeof docKey === 'string') {
            this.router.navigate(['accounts', 'loans', 'legal'], {state: {documentsKey: docKey}});
            return false;
          } else {
            this.router.navigate(['home']);
            return false;
          }
        }
      }
      )
    )
  }

}
